import { Box, Grid, IconButton, Stack, Typography } from '@mui/material'
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded'
import MovieCreationRoundedIcon from '@mui/icons-material/MovieCreationRounded'
import React from 'react'
import useStyles from './_styles'
import { CardContainerPJProps } from './_props'
import { DeleteRoundedIcon, EditBlackIcon, VisibilityEyeIcon } from 'apps/ids/src/app/assets/icons/icons'

export default function CardContainerPJ({
    title,
    list,
    isUploading,
    onRenaming,
    onPreview,
    onConfirmDelete,
}: CardContainerPJProps) {
    const classes = useStyles()
    if (list.length === 0) return null

    const handleActionClick = (event: React.MouseEvent, callback: () => void) => {
        event.preventDefault()
        event.stopPropagation()
        callback()
    }

    const renderThumbnail = (item: any) => {
        if (item.mediaType === 'picture' && item.url) {
            return <img className={classes.thumbImg} src={item.url} alt={item.name} />
        }
        const isDocument = item.mediaType === 'document'
        const Icon = isDocument ? DescriptionRoundedIcon : MovieCreationRoundedIcon
        return (
            <Box className={classes.thumbIconWrap}>
                <Icon
                    className={classes.thumbIcon}
                    sx={{
                        backgroundColor: isDocument ? '#E7E8FF' : 'transparent',
                        padding: '0.5rem',
                        borderRadius: '50%',
                        fontSize: '2rem',
                    }}
                />
            </Box>
        )
    }

    return (
        <Stack gap="1rem">
            <Typography className={classes.sectionTitle}>{title}</Typography>
            <Box className={classes.cardsContainer}>
                {list.map((item) => (
                    <Box className={classes.cardItem} key={item.id}>
                        <Box className={classes.containerCardPJ}>
                            <Box className={classes.thumb}>{renderThumbnail(item)}</Box>
                            <Box className={classes.cardActionsRow}>
                                <IconButton
                                    className={classes.actionButton}
                                    onClick={(event) => handleActionClick(event, () => onRenaming(item.id, item.name))}
                                    disabled={isUploading}
                                >
                                    <EditBlackIcon />
                                </IconButton>
                                <IconButton
                                    className={classes.actionButton}
                                    onClick={(event) => handleActionClick(event, () => onPreview(item.id))}
                                    disabled={isUploading}
                                >
                                    <VisibilityEyeIcon />
                                </IconButton>
                                <IconButton
                                    className={classes.actionButtonDelete}
                                    onClick={(event) => handleActionClick(event, () => onConfirmDelete(item.id))}
                                    disabled={isUploading}
                                >
                                    <DeleteRoundedIcon />
                                </IconButton>
                            </Box>
                        </Box>
                        <Typography className={classes.cardName} title={item.name}>
                            {item.name}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Stack>
    )
}
